/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserModel } from '@shared/models/user.model';
import { Device } from '@capacitor/device';
import { Observable, catchError, from, map, tap, timeout, EMPTY, firstValueFrom } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { getSoulOid } from '@shared/utils/soul-id.util';
import { LanguageEnum } from '@shared/enums/LanguageEnum';
import { Platform, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Preferences } from '@capacitor/preferences';
import { LocationService } from './location.service';
import { Router } from '@angular/router';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { App } from '@capacitor/app';
import { FileTransfer, FileTransferObject, FileUploadOptions, FileUploadResult } from '@awesome-cordova-plugins/file-transfer';
import { webVersion } from 'src/environments/environment';
import { FirebaseAnalyticsService } from './firebase-analytics.service';
@Injectable({
  providedIn: 'root'
})

export class UserService {
  public theSoul: any;
  // private myBaseURL: String = endPoints.myProtocol + '//' + endPoints.myHost + ':' + endPoints.myPort;
  private userdevice: any;
  public static loggedOut: boolean = false;
  public static termsAcceptedOn: Date | any = null;
  public static serverUnreacheableMsg: string = 'unableToConnectMsg';
  public static serverUnreacheableMsgTime: number = 4000;


  private fileTransfer: FileTransferObject | any;

  constructor(
    private router: Router,
    private translate: TranslateService,
    public http: HttpClient,
    private userModel: UserModel,
    public loadingCtrl: LoadingController,
    public locationService: LocationService,
    private platform: Platform,
    private firebaseAnalytics: FirebaseAnalyticsService,
  ) {
    this.platform.ready().then(async () => {
      this.fileTransfer = FileTransfer.create();

      if (Capacitor.isNativePlatform()) {
        App.getInfo().then(async (appInfo) => {
          if (appInfo.version != null) {
            const device = await Device.getInfo();
            const myDevice = {
              manufacturer: device.manufacturer,
              model: device.model,
              version: device.osVersion,
              platform: device.platform,
              uuid: (await Device.getId()).identifier,
              appVersion: (await App.getInfo()).version
            }

            console.log('Device Obj: ' + JSON.stringify(myDevice));
            this.userdevice = myDevice;
          }
        }, async _err => {
          // Browser used to enter here. Should not enter anymore but keeping for now just in case
          const device = await Device.getInfo();
          const _myDevice = {
            manufacturer: device.manufacturer,
            model: device.model,
            version: device.osVersion,
            platform: device.platform,
            uuid: (await Device.getId()).identifier,
            appVersion: webVersion
          }
        })

      } else {
        // Browser will enter here

        const device = await Device.getInfo();
        const myDevice = {
          manufacturer: device.manufacturer,
          model: device.model,
          version: device.osVersion,
          platform: device.platform,
          uuid: (await Device.getId()).identifier,
          appVersion: webVersion
        }

        this.userdevice = myDevice;
      }

    });

    if (this.platform.is('android')) {
      // endPoints.myHost = endPoints.androidHost;
      // this.myBaseURL = endPoints.myProtocol + '//' + endPoints.myHost + ':' + endPoints.myPort;
    }
  }


  private user: Promise<UserModel> = Preferences.get({ key: 'USER_DATA' }).then(
    data => data && data.value ? JSON.parse(data.value) : null
  );

  hasUser() {
    // alert(localStorage.getItem('USER_LOGGED'))
    return localStorage.getItem('USER_LOGGED')
    //return this.user.then(user => !!user);
  }


  static readonly ACQUISITION_ATTRIBUTION_KEY = 'ACQUISITION_ATTRIBUTION';
  static readonly ACQUISITION_KEYS = [
    'gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign',
    'utm_term', 'utm_content', 'campaignid', 'adgroupid', 'creative',
    'keyword', 'matchtype', 'network', 'device', 'placement',
    'referralUserId', 'landingPageId'
  ];

  public captureAcquisitionAttribution(url: string): Record<string, string> | null {
    try {
      const parsed = new URL(url);
      const values: Record<string, string> = {};
      UserService.ACQUISITION_KEYS.forEach(key => {
        const value = parsed.searchParams.get(key);
        if (value) values[key] = value.substring(0, 500);
      });
      if (!Object.keys(values).length) return null;
      values['landingPath'] = parsed.pathname.substring(0, 500);
      localStorage.setItem(UserService.ACQUISITION_ATTRIBUTION_KEY, JSON.stringify(values));
      return values;
    } catch {
      return null;
    }
  }

  public getPendingAcquisitionAttribution(): Record<string, string> | null {
    try {
      const raw = localStorage.getItem(UserService.ACQUISITION_ATTRIBUTION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  public clearPendingAcquisitionAttribution(): void {
    try {
      localStorage.removeItem(UserService.ACQUISITION_ATTRIBUTION_KEY);
    } catch {
      // ignore quota / private mode
    }
  }

  upsertSoul(userData: any, locationJson: any, checkUserExists: boolean, reorderPictures: boolean, isLoginOrCreate: boolean): Observable<any> {
    //if (locationJson != null && !(locationJson.coordinates[0] === MyApp.londonLocation.coordinates[0] && locationJson.coordinates[1] === MyApp.londonLocation.coordinates[1]))
    if (locationJson != null && !(locationJson.coordinates[0] === environment.locationDefault.coordinates[0] && locationJson.coordinates[1] === environment.locationDefault.coordinates[1])) {
      userData.location = locationJson;
    }
    if (UserService.termsAcceptedOn != null) {
      userData.termsAcceptedOn = UserService.termsAcceptedOn;
    }
    // if (AppComponent.idfa != null) {
    //   userData.idfa = AppComponent.idfa;
    // }
    // if (AppComponent.aaid != null) {
    //   userData.aaid = AppComponent.aaid;
    // }
    // Only attach acquisition on login/create — not on profile updates or
    // checkUserExists probes (forgot-password), which would consume or mis-attribute.
    const campaignAttribution =
      isLoginOrCreate && !checkUserExists
        ? this.getPendingAcquisitionAttribution()
        : null;
    if (campaignAttribution) {
      // Ad UTMs travel in campaignAttribution. referralUserId stays on
      // userData.referralUserId (email / Google/FB landing / Apple createConfirmed)
      // so returning logins are not re-credited via the attribution blob.
      const attrs = { ...campaignAttribution };
      delete attrs['referralUserId'];
      if (Object.keys(attrs).length) {
        userData.campaignAttribution = attrs;
      }
    }
    const thePostURL: string = environment.mainServer + '/soul';
    const headerValues: any = new Object();
    if (userData.email != null) {
      headerValues.email = userData.email;
    }
    if (checkUserExists) {
      headerValues.checkUserExists = 'true';
    }
    if (reorderPictures) {
      headerValues.reorderPictures = 'true';
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    if (isLoginOrCreate) {
      headerValues.isLoginOrCreate = 'true';
    } else {
      headerValues.isLoginOrCreate = 'false';
    }

    return from(
      this.http.post(thePostURL, JSON.stringify(userData), {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          tap((data) => {
            // Backend signals auth/create failure as HTTP 200 + '{not ok}'.
            // Keep attribution so a later successful login/create can still claim it.
            if (campaignAttribution && data !== '{not ok}') {
              this.clearPendingAcquisitionAttribution();
            }
          }),
          catchError(this.handleError)
        )
    );
  }


  public uploadImage64(localFile: string, userData: any, filename: string): Observable<any> {
    const userId = userData?._id.$oid;
    const headerValues: any = new Object();
    headerValues.owner = userId;
    headerValues.fileName = filename;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    return this.http.post(environment.mainServer + '/soul/image64', localFile, { headers: headerValues, responseType: 'text' })
      .pipe(
        timeout(environment.requestTimeout),
        map((data) => data),
        catchError(this.handleError)
      );
  }




  async getDevice() {
    return await Device.getInfo()
  }

  public findSoulByEmailAndPassword(email: string, password: string): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul';
    console.log(theRequest);

    const myHeaders = new HttpHeaders({ 'password': password, 'email': email });
    console.log('myHeaders: ' + JSON.stringify(myHeaders));

    //let myHeaders: HttpHeaders = new HttpHeaders('password='+password);
    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  private handleError(error: HttpErrorResponse) {
    //alert("Error connecting to the server");

    console.error('Error connecting to the server:', JSON.stringify(error));
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `Body was: ${error.error}` +
        `StatusText was: ${error.statusText}` +
        `Message was: ${error.message}`);
      //if (error.error instanceof XMLHttpRequestProgressEvent) {
      //}
    }

    /* A mensagem passa a DIZER o que falhou.
    
       Os 48 endpoints deste servico passam por aqui, e todos jogavam fora o unico dado util:
       o `console.error` acima imprime status, corpo e URL, mas o `Error` lancado so carregava
       a frase generica. Consequencia: no Crashlytics toda falha de HTTP chega identica, e o
       alerta de debug (GlobalErrorHandler, so em build nao-producao) mostra um stacktrace de
       frames do RxJS sem dizer QUAL requisicao caiu.
    
       A frase generica continua no inicio — nada na UI exibe `err.message`, conferido nas
       paginas e nos componentes compartilhados, entao isto nao muda texto que o usuario le, e
       o spec que verifica `toContain('Something bad happened')` segue valendo.
    
       `status` e `url` tambem vao como propriedades, para quem tratar o erro poder decidir sem
       parsear string. */
    const alvo = error.url ?? 'URL desconhecida';
    const detalhe = error.status
      ? `HTTP ${error.status} ${error.statusText ?? ''}`.trim()
      : 'falha de rede/CORS (status 0)';
    const erroLancado = new Error(
      `Something bad happened; please try again later. [${detalhe} em ${alvo}]`,
    );
    (erroLancado as Error & { status?: number; url?: string | null }).status = error.status;
    (erroLancado as Error & { status?: number; url?: string | null }).url = error.url;

    return throwError(() => erroLancado);
  }

  public validateTempCode(userData: any, code: string): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/validateTempCode';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.code = code;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public setEmailValidated(soulId: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/setEmailValidated?soul=' + soulId;
    console.log(theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public calculateAge(birthday: Date): number {
    // TODO test it's working when birth is coming from Facebook
    //      console.log('birthday is ' + birthday.toDateString());
    if (birthday == null) {
      return 0;
    }
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  public igToken(userData: any, code: string): Observable<any> {
    const soulId = userData?._id.$oid;
    const theRequest: string = environment.mainServer + '/soul/igToken';
    console.log('the igToken request: ' + theRequest);

    const headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.code = code;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public getImageURL(picId: string): string {
    // IMPORTANTE: usar environment.imgServer (NAO getApiBase()) — em prod imgServer e
    // mainServer apontam pra hosts diferentes (img2.veggly.net vs api2.veggly.net).
    // Trocar pra getApiBase() quebrou imagens em prod (commit e4546f168).
    return `${environment.imgServer}/similarsouls/image.files/${picId}/binary`;
  }

  /**
   * URL alternativa (origem mainServer/api2) para a MESMA imagem. Usada como fallback
   * quando a origem primária (imgServer/img2) é bloqueada pelo CDN na web
   * (ERR_BLOCKED_BY_RESPONSE.NotSameOrigin — CORP/403 do Cloudflare na rajada do feed).
   * Retorna null quando não há host alternativo (dev, ou imgServer === mainServer).
   */
  public getImageFallbackURL(picId: string): string | null {
    const imgBase = (environment.imgServer || '').replace(/\/$/, '');
    const mainBase = (environment.mainServer || '').replace(/\/$/, '');
    if (!mainBase || mainBase === imgBase) return null;
    return `${mainBase}/similarsouls/image.files/${picId}/binary`;
  }

  /** Web app base URL without trailing slash (e.g. https://app.fyradating.com). */
  public getShareBaseUrl(): string {
    return environment.mainUrlWeb.trim().replace(/\/*$/, '');
  }

  public getReferralShareUrl(userId: string): string {
    return `${this.getShareBaseUrl()}?referralUserId=${userId}`;
  }

  public getAffiliateLanding(affiliateId: string): Observable<any> {
    const safeId = encodeURIComponent(affiliateId);
    return this.http.get(environment.mainServer + '/soul/affiliateLanding/' + safeId).pipe(
      timeout(environment.requestTimeout),
      catchError(this.handleError)
    );
  }

  public extractReferralUserId(url: string): string | null {
    try {
      const parsed = new URL(url);
      const id = parsed.searchParams.get('referralUserId');
      if (id) {
        return id.split('&')[0];
      }
    } catch {
      // relative or non-standard URL
    }
    const match = url.match(/[?&]referralUserId=([^&]+)/);
    return match?.[1] ?? null;
  }

  /** Persisted across onboarding so install prompt / copy don't depend on the live URL. */
  static readonly REFERRAL_JOIN_PENDING_KEY = 'REFERRAL_JOIN_PENDING';
  static readonly REFERRAL_SOURCE_KEY = 'REFERRAL_SOURCE';

  /**
   * Detect affiliate vs friend from getPublicProfileById (or upsert) payload.
   * Backend should expose one of: isAffiliate, affiliate, referralType='affiliate'.
   * Public profile currently often only returns _id/firstName/firstPic — until then this stays 'friend'.
   */
  public resolveReferralSource(profileOrUser: any): 'friend' | 'affiliate' {
    if (!profileOrUser || typeof profileOrUser !== 'object') {
      return 'friend';
    }
    if (
      profileOrUser.isAffiliate === true ||
      profileOrUser.affiliate === true ||
      profileOrUser.isAffiliateReferral === true ||
      profileOrUser.referralType === 'affiliate' ||
      profileOrUser.referralSource === 'affiliate'
    ) {
      return 'affiliate';
    }
    const granted = Number(
      profileOrUser.referralCoinsGranted ?? profileOrUser.receivedReferralCoins ?? NaN
    );
    if (!Number.isNaN(granted) && granted > 1) {
      return 'affiliate';
    }
    return 'friend';
  }

  public async markReferralJoinPending(source: 'friend' | 'affiliate' = 'friend'): Promise<void> {
    await Preferences.set({ key: UserService.REFERRAL_JOIN_PENDING_KEY, value: 'true' });
    await Preferences.set({ key: UserService.REFERRAL_SOURCE_KEY, value: source });
  }

  public async setReferralSource(source: 'friend' | 'affiliate'): Promise<void> {
    await Preferences.set({ key: UserService.REFERRAL_SOURCE_KEY, value: source });
  }

  public async getReferralSource(): Promise<'friend' | 'affiliate'> {
    const { value } = await Preferences.get({ key: UserService.REFERRAL_SOURCE_KEY });
    return value === 'affiliate' ? 'affiliate' : 'friend';
  }

  /** Returns true once if a referral join is pending, then clears the pending flag (keeps source for congrats). */
  public async consumeReferralJoinPending(): Promise<boolean> {
    const { value } = await Preferences.get({ key: UserService.REFERRAL_JOIN_PENDING_KEY });
    if (value !== 'true') {
      return false;
    }
    await Preferences.remove({ key: UserService.REFERRAL_JOIN_PENDING_KEY });
    return true;
  }

  public async clearReferralJoinContext(): Promise<void> {
    await Preferences.remove({ key: UserService.REFERRAL_JOIN_PENDING_KEY });
    await Preferences.remove({ key: UserService.REFERRAL_SOURCE_KEY });
  }

  /** Same-origin on ionic serve (proxy); full URL on native builds. */
  private getApiBase(): string {
    if (Capacitor.isNativePlatform()) {
      return environment.mainServer;
    }
    if (!environment.production) {
      return '';
    }
    return environment.mainServer;
  }

  private getProfileImageDownloadUrls(picId: string): string[] {
    // Same URL as <img> src (getImageURL). Do not use getApiBase() here: on
    // ionic serve it is '' and the fallbacks become localhost:8100/soul/image/...
    const urls = [this.getImageURL(picId)];
    const imgBase = (environment.imgServer || '').replace(/\/$/, '');
    const mainBase = (environment.mainServer || '').replace(/\/$/, '');
    if (mainBase && mainBase !== imgBase) {
      urls.push(`${mainBase}/similarsouls/image.files/${picId}/binary`);
    }
    return urls.filter((value, index, arr) => !!value && arr.indexOf(value) === index);
  }

  private blobToDataUrl(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  private async downloadImageAsDataUrl(imageUrl: string): Promise<string | null> {
    try {
      const blob = await firstValueFrom(
        this.http.get(imageUrl, { responseType: 'blob' })
      );
      if (blob && blob.size > 0) {
        return await this.blobToDataUrl(blob);
      }
    } catch (e) {
      console.warn('[UserService] downloadImageAsDataUrl failed', imageUrl, e);
    }
    return null;
  }

  /** Native HTTP bypasses WebView CORS for profile image bytes. */
  private async downloadImageAsDataUrlNative(imageUrl: string): Promise<string | null> {
    try {
      const response = await CapacitorHttp.get({
        url: imageUrl,
        responseType: 'blob',
      });
      if (response.status < 200 || response.status >= 300 || !response.data) {
        return null;
      }
      const data = response.data as string;
      if (typeof data !== 'string' || data.length === 0) {
        return null;
      }
      if (data.startsWith('data:')) {
        return data;
      }
      const headers = response.headers as Record<string, string> | undefined;
      const contentType =
        headers?.['Content-Type'] ?? headers?.['content-type'] ?? 'image/jpeg';
      return `data:${contentType};base64,${data}`;
    } catch (e) {
      console.warn('[UserService] CapacitorHttp image download failed', imageUrl, e);
    }
    return null;
  }

  /**
   * Loads profile picture bytes for share/screenshot compositing.
   */
  public async loadProfilePictureDataUrl(picId: string): Promise<string | null> {
    const urls = this.getProfileImageDownloadUrls(picId);
    const download = Capacitor.isNativePlatform()
      ? (url: string) => this.downloadImageAsDataUrlNative(url)
      : (url: string) => this.downloadImageAsDataUrl(url);

    for (const url of urls) {
      const dataUrl = await download(url);
      if (dataUrl) {
        return dataUrl;
      }
    }

    return null;
  }

  /**
   * Search for the first available picture of an user
   * @param soul 
   * @returns oid from the first available picture
   */
  getFirstAvailablePicture(soul: any): string {
    for (let i = 0; i <= 8; i++) {
      const pictureSlot = soul[`picture${i}`];
      if (pictureSlot) {
        return pictureSlot.$oid;
      }
    }
    return "";
  }


  public igPhotos(userData: any, token: string): Observable<any> {
    const soulId = userData?._id.$oid;
    const theRequest: string = environment.mainServer + '/soul/igGetMediaForUser';
    console.log('the igGetMediaForUser request: ' + theRequest);

    const headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.token = token;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public igMorePhotos(userData: any, token: string, igid: string, after: string): Observable<any> {
    const soulId = userData?._id.$oid;
    const theRequest: string = environment.mainServer + '/soul/igGetMoreMediaForUser';
    console.log('the igGetMediaForUser request: ' + theRequest);
    const headerValues: any = new Object();
    headerValues.owner = soulId;
    headerValues.token = token;
    headerValues.igid = igid;
    headerValues.after = after;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }
  public setEmailPreferences(me: any, doNotContact: boolean, emailPreferences: any): Observable<any> {
    if (!me || !me._id || !me._id.$oid) {
      console.error('setEmailPreferences: Invalid user data structure', me);
      return throwError(() => new Error('Invalid user data structure'));
    }

    const userId = me._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/setEmailPreferences';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.doNotContact = "" + doNotContact;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    console.log('setEmailPreferences myHeaders: ' + JSON.stringify(headerValues));
    console.log('setEmailPreferences emailPreferences: ' + JSON.stringify(emailPreferences));

    return this.http.post(thePostURL, emailPreferences, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }
  public deleteFile(soulId: string, filename: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/image/delete?owner=' + soulId + "&filename=" + filename;
    console.log('the delefeFile request: ' + theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(

      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public setEmailPreferencesUnsubscribe(email: string, doNotContact: boolean, emailPreferences: any): Observable<any> {

    const thePostURL: string = environment.mainServer + '/soul/setEmailPreferencesUnsubscribe';

    const headerValues: any = new Object();
    headerValues.email = email;
    headerValues.doNotContact = "" + doNotContact;

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, emailPreferences, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  checkUserHasPicture(userData: any): boolean {
    if (!userData) return false;
    for (let i = 0; i < 9; i++) {
      const pic = userData['picture' + i];
      if (pic && pic.$oid) {
        return true;
      }
    }
    return false;
  }


  public refreshMyData(userData: any, getDeletedLikes?: boolean): Observable<any> {
    console.log("=============refreshMyData=============")
    console.log(userData)

    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/refreshMyData';
    const headerValues: any = new Object();
    headerValues.soul = userId;
    console.log('this.userdevice: ' + JSON.stringify(this.userdevice));
    if (this.userdevice != null) {
      headerValues.device = JSON.stringify(this.userdevice);
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    if (getDeletedLikes != null) {
      headerValues.getDeletedLikes = getDeletedLikes + "";
    }

    if (userData.language != undefined && userData.language != null) {
      headerValues.language = userData.language;
    }

    return from(
      this.http.post(thePostURL, '', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }


  public logout(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    // Nota: Não removemos TELEPORT_LOCATION aqui para manter o último teletransporte do usuário após logout
    // this.locationService.removeTeleportationLocation(userData); // REMOVIDO - preserva teletransporte após logout
    const theRequest: string = environment.mainServer + '/soul/logout?soul=' + userId;
    console.log(theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(theRequest, null, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  async clearLocalStorage() {
    try {
      console.log("Starting clearLocalStorage...");

      // Lê USER_DATA antes de limpar para fazer backup do teletransporte do mesmo usuário
      let userId: string | null = null;
      try {
        const userDataPref = await Preferences.get({ key: 'USER_DATA' });
        if (userDataPref?.value) {
          const userData = JSON.parse(userDataPref.value);
          userId = LocationService.getUserIdFromUser(userData);
        }
      } catch (_) {}
      // Reseta teletransporte (e salva backup se userId presente para mesmo usuário restaurar no login)
      await this.locationService.resetTeleportationOnLogout(userId);

      // Array de todas as chaves a serem removidas
      const keysToRemove = [
        'USER_DATA',
        'LOCAL_PROMOTION',
        'USER_LOGGED',
        'CHAT_FIRST_OPEN_DATE',
        'WORKING_ON_INDEX',
        'LAST_LOCATION',
        'IN_CHECKOUT',
        'REFRESH',
        'MODAL_SHOWN_COUNT',
        // A lista de conversas e o contador do modal sao POR USUARIO. Sem remove-los
        // aqui, o proximo login herda o cache de quem saiu: o MatchService carrega
        // MATCHES no construtor sem checar de quem e', e a chat list mostra conversas
        // de outra conta. Ver tambem a validacao de dono em match.service.ts.
        'MATCHES',
        'MATCHES_OWNER',
        'MATCHES_MODAL'
      ];

      // Variável para rastrear se todas as chaves foram removidas com sucesso
      let allKeysRemoved = true;

      // Loop para remover cada chave
      for (const key of keysToRemove) {
        try {
          await Preferences.remove({ key });
          console.log(`Deleted ${key}`);
        } catch (error) {
          console.error(`Failed to delete key: ${key}`, error);
          allKeysRemoved = false; // Marca como falso se falhar em remover qualquer chave
        }
      }
      // Limpa todo o localStorage
      localStorage.clear();

      // Clear GA4 identity whenever local session data is wiped — even if some
      // Preferences keys failed. Fire-and-forget: logout must not wait on the
      // writeChain (queued registerEvent calls can each take up to the plugin timeout).
      void this.firebaseAnalytics.setUserId(null, undefined, true).catch((error) => {
        console.error('Failed to clear Firebase Analytics user ID:', error);
      });

      if (allKeysRemoved) {
        // Define o estado de loggedOut para true
        UserService.loggedOut = true;

        // Cria e apresenta o loader
        const loader = await this.loadingCtrl.create({
          message: this.translate.instant('logout')
        });
        await loader.present();

        // Timer para aguardar 2 segundos e depois redirecionar
        setTimeout(async () => {
          await loader.dismiss();
          this.router.navigateByUrl('/login');
        }, 2000);
      } else {
        console.error("Not all keys were removed. Aborting navigation to login.");
      }
    } catch (error) {
      console.error("Error in clearLocalStorage:", error);
    }
  }


  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }

  async deleteImages() {

    let i;
    for (i = 0; i < 9; i++) {
      const _index: number = i;
      const _aFile: string = this.createFileName(i);
    }

  }

  public getHiddenProfiles(userData: any, page: number): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/getHiddenProfiles';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.page = page + '';
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }


    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public unhideSoul(me: any, soulToUnhide: any): Observable<any> {
    const userId = me._id.$oid;
    const hiddenUserId = soulToUnhide._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/unhideSoul';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.soulToUnhide = hiddenUserId;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public hideSoul(me: any, soulToHide: any): Observable<any> {
    const userId = me._id.$oid;
    const hiddenUserId = soulToHide._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/hideSoul';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.soulToHide = hiddenUserId;
    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public respondSurvey(me: any, surveyResponses: any): Observable<any> {
    const userId = me._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/respondSurvey5';

    const headerValues: any = new Object();
    headerValues.soul = userId;

    if (me.hash != null) {
      headerValues.key = me.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    console.log('respondSurvey myHeaders: ' + JSON.stringify(headerValues));
    console.log('respondSurvey surveyResponses: ' + JSON.stringify(surveyResponses));

    return this.http.post(thePostURL, surveyResponses, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public markRead(me: any, otherSoul: any, isMessage: boolean): Observable<any> {
    const soulId = getSoulOid(me);
    const otherSoulId = getSoulOid(otherSoul);

    if (!soulId || !otherSoulId) {
      console.warn('markRead missing ids', { soulId, otherSoulId, me, otherSoul });
      return EMPTY;
    }

    const params = new HttpParams()
      .set('soul', soulId)
      .set('otherSoul', otherSoulId)
      .set('message', String(isMessage));

    const theRequest = environment.mainServer + '/soul/markRead';
    console.log('the markRead request: ' + theRequest + '?' + params.toString());

    return this.http.get(theRequest, { params, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public getMatches(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/getMatches?soul=' + userId;

    /* Removed this logic because it could have new matches in the server
    if(userData.matches === null && userData.matches.length === 0){
      return null;
    }
    */
    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);


    console.log('thePostURL: ' + thePostURL);
    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(30000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  /**
  * Collect from the DB the souls that liked the user.
  * @param userData - The user we want to collect who liked him
  * @returns - List with the souls that liked the user
  */
  public async getLikedBy(userData: any, page: number): Promise<any> {
    const userId = userData?._id.$oid;

    const headerValues: any = new Object();
    headerValues.likedBy = "true";
    headerValues.owner = userId;
    headerValues.page = '' + page;

    headerValues.lon = "any"
    headerValues.lat = "any"

    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    console.log("Header values: " + JSON.stringify(headerValues));
    console.log("LikedBySouls")
    console.log(userData.likedBySouls);

    this.fetchData(headerValues).subscribe({
      next: (response) => {
        console.log('Resposta recebida:', response);
      },
      error: (err) => {
        console.error('Erro durante a chamada:', err);
      },
      complete: () => {
        console.log('Requisição completa.');
      },
    });
  }

  /**
   * Make a call to DB
   * 
   */
  public fetchData(headerValues: any): Observable<any> {
    return from(
      this.http.get(environment.mainServer + '/soul/findnearby2', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }

  public findNearby(userData: any, lon: any, lat: any, token: string, page: number, likedBy: boolean, sort: string): Observable<any> {

    const userId = userData?._id.$oid;
    console.log('sour-service.findnearby - userData?._id.$oid: ' + userId);

    const headerValues: any = new Object();
    headerValues.likedBy = likedBy ? 'true' : 'false';
    headerValues.sort = sort;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    headerValues.owner = userId;
    headerValues.lon = '' + lon;
    headerValues.lat = '' + lat;
    headerValues.token = token;
    headerValues.page = '' + page;
    let appversion = '2.4.4';
    if (this.userdevice != undefined && this.userdevice != null && this.userdevice.appVersion != null && this.userdevice.appVersion != undefined) {
      appversion = this.userdevice.appVersion;
    }
    headerValues.upgraded = appversion; // header value started on version 1.7.0. 

    return from(
      this.http.get(environment.mainServer + '/soul/findnearby2', {
        headers: headerValues,
        responseType: 'text',
      })
        .pipe(
          timeout(environment.requestTimeout),
          map((data) => data),
          catchError(this.handleError)
        )
    );
  }

  public getDistance(me: any, aSoul: any): string {
    const teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      console.log('loadCurrentPage will use teleportationLocation: ' + JSON.stringify(teleportationLocation));
      me.location = teleportationLocation;
    }

    const otherLon = aSoul.location.coordinates[0];
    const otherLat = aSoul.location.coordinates[1];
    const lon = me.location.coordinates[0];
    const lat = me.location.coordinates[1];
    let distance: number = this.getDistanceFromLatLonInMiles(lat, lon, otherLat, otherLon);

    const isKm = me.distanceUnit != null && me.distanceUnit == 'km';
    if (isKm) {
      distance *= 1.60934;
    }

    const dist: string = distance.toFixed(0);
    let distText: string;
    if (dist == '1' || dist == '0') {
      distText = isKm ? this.translate.instant('within1Kilometer') : this.translate.instant('within1Mile');
    } else {
      distText = dist + ' ' + (isKm ? this.translate.instant('kilometers') : this.translate.instant('miles'));
    }

    return distText;
  }

  /**
   * Parse distance from backend (number, string, or BSON-style object) to km number.
   * Use when backend returns distance for app 3.0+ (getUserById / findNearby2).
   */
  public parseBackendDistanceKm(value: any): number {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }
    if (typeof value === 'string') {
      const n = parseFloat(value);
      return Number.isFinite(n) && n >= 0 ? n : 1;
    }
    if (value && typeof value === 'object' && '$numberDouble' in value) {
      const n = parseFloat((value as { $numberDouble: string }).$numberDouble);
      return Number.isFinite(n) && n >= 0 ? n : 1;
    }
    return 1;
  }

  /**
   * Format a distance in km for display (when backend returns distance for app 3.0+).
   * @param distanceKm distance in kilometers (from backend getUserById)
   * @param useKm if false, convert to miles for display
   */
  public formatDistanceFromKm(distanceKm: number, useKm: boolean): string {
    if (!Number.isFinite(distanceKm) || distanceKm < 0) {
      distanceKm = 1;
    }
    const distance = useKm ? distanceKm : distanceKm / 1.60934;
    const dist: string = distance.toFixed(0);
    if (dist == '1' || dist == '0') {
      return useKm ? this.translate.instant('within1Kilometer') : this.translate.instant('within1Mile');
    }
    return dist + ' ' + (useKm ? this.translate.instant('kilometers') : this.translate.instant('miles'));
  }

  public getDistanceFromLatLonInMiles(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 3958; // Radius of the earth in miles
    const dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in mi
    return d;
  }

  public deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }




  public getNewMessagesMatches(soulId: string, since: number, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/getNewMessages?soul=' + soulId + '&since=' + since;
    console.log('the getNewMessagesMatches request: ' + theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public markSuperLikesRead(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/markSuperLikesRead';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getSuperLikes(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/getSuperLikes';

    const headerValues: any = new Object();
    headerValues.soul = userId;

    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public formatDate(d: any, userData: any) {
    const curr_date = d.getDate();
    const curr_month = d.getMonth() + 1; //Months are zero based
    const curr_year = d.getFullYear();

    let formattedDate: string;
    if (userData.language != null && userData.language != 'en') {
      formattedDate = curr_date + "/" + curr_month + "/" + curr_year;
    } else {
      formattedDate = curr_month + "/" + curr_date + "/" + curr_year;
    }

    return formattedDate;
  }

  /**
   * Cache do formatador de hora, por idioma.
   *
   * `Intl.DateTimeFormat` nao e barato de construir, e o `formatTime` roda uma vez POR
   * MENSAGEM ao montar a conversa. Antes um formatador novo nascia a cada chamada.
   */
  private formatadorDeHora: { idioma: string; fmt: Intl.DateTimeFormat } | null = null;

  /**
   * Idioma que manda na formatacao: o do APP, nao o do aparelho.
   *
   * O `translate.currentLang` e o idioma que o app esta exibindo — resolvido pelo
   * `UtilService.resolveTranslateLanguage` a partir do que o usuario informou, com as regras
   * dele (escolha manual, codigos legados). Usar essa mesma fonte e o que mantem a hora
   * coerente com o resto da tela.
   *
   * O `UtilService` NAO pode ser importado aqui: o `util.ts` importa este servico, e o ciclo
   * quebraria o build. Por isso a normalizacao e refeita contra o `LanguageEnum`, que e folha.
   */
  private idiomaDoApp(): string {
    const bruto = this.translate?.currentLang || this.translate?.getDefaultLang();
    const base = String(bruto ?? '').toLowerCase().split(/[-_]/)[0];
    const suportados = Object.values(LanguageEnum) as string[];
    return suportados.includes(base) ? base : LanguageEnum.EN;
  }

  /**
   * Hora da mensagem no formato do IDIOMA ESCOLHIDO NO APP.
   *
   * Vinha de `navigator.language`, que e o idioma do APARELHO: quem usava o app em ingles num
   * celular configurado em portugues via 14:05, e quem usava em portugues num celular em
   * ingles via 2:05 PM. O 12h/24h e o proprio AM/PM nunca foram decididos aqui — quem decide e
   * o locale, e isso continua: medido nos nove idiomas do app, `en` da "2:05 PM", `ko` da
   * "오후 2:05" e os outros sete dao "14:05".
   */
  public formatTime(d: Date) {
    const idioma = this.idiomaDoApp();
    if (!this.formatadorDeHora || this.formatadorDeHora.idioma !== idioma) {
      this.formatadorDeHora = {
        idioma,
        // Sem `hour12`: e o locale que decide, que e justamente o comportamento desejado.
        fmt: new Intl.DateTimeFormat(idioma, { hour: 'numeric', minute: '2-digit' }),
      };
    }
    return this.formatadorDeHora.fmt.format(d);
  }

  public getSentSuperLikes(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/getSentSuperLikes';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public postBoost(userData: any, data: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/boostme';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, data, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getMessages(userData: any, otherSoul: any): Observable<any> {
    const userId = userData?._id.$oid;
    const otherSoulId = otherSoul._id.$oid;

    const theRequest: string = environment.mainServer + '/soul/getMessages?sendingSoul=' + userId + '&receivingSoul=' + otherSoulId;
    console.log(theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  public getNewMessages(userData: any, otherSoul: any, lastMsg: any): Observable<any> {
    const userId = userData?._id.$oid;
    const otherSoulId = otherSoul._id.$oid;
    //      let LasMsgId = lastMsg._id.$oid;
    const LasMsgId = lastMsg != null ? lastMsg._id.$oid : '0';

    const theRequest: string = environment.mainServer + '/soul/getMessagesSince?sendingSoul=' + userId + '&receivingSoul=' + otherSoulId + '&fromMsg=' + LasMsgId;
    console.log(theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    headerValues.getReadLastMessage = 'true';
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
    //alert(JSON.stringify(this.theSoul));
  }

  public sendMessage(sendingSoul: string, receivingSoul: string, msg: string, userData: any, respondedMessage?: string, recadinho?: boolean, photoId?: any): Observable<any> {
    let thePostURL: string = environment.mainServer + '/soul/sendMessage?sendingSoul=' + sendingSoul + '&receivingSoul=' + receivingSoul;
    // Elogio (Compliment): mesmo endpoint do chat, com &compliment=true e o pictureId (ObjectId
    // da foto alvo). O servidor faz a curtida automática, cobra 1 cenoura/spark e envia o email.
    // Respostas: _id do chat (ok) | {No Coins} (sem moeda) | {not ok} (auth / pictureId inválido /
    // foto não é do destinatário / erro).
    if (recadinho) {
      thePostURL += '&compliment=true';
      if (photoId != null && photoId !== '') {
        thePostURL += '&pictureId=' + encodeURIComponent(photoId);
      }
    }
    console.log('thePostURL: ' + thePostURL);

    const headerValues: any = new Object();
    if (respondedMessage) {
      headerValues.inResponseTo = respondedMessage;
    }
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, msg, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public reactToMessage(messageId: string, reaction: number, userData: any): Observable<any> {
    const thePostURL: string = environment.mainServer + '/soul/reactToMessage';

    const headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    headerValues.messageId = messageId;
    headerValues.reaction = '' + reaction;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public undoReactionToMessage(messageId: string, reaction: number, userData: any): Observable<any> {
    const thePostURL: string = environment.mainServer + '/soul/undoReactionToMessage';

    const headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    headerValues.messageId = messageId;
    headerValues.reaction = '' + reaction;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, null, { headers: myHeaders, responseType: 'json' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }


  public viewProfile(profileUserId: any, userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/getUserById';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    headerValues.idtoget = profileUserId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    let appversion = '2.0.0';
    if (this.userdevice != undefined && this.userdevice != null && this.userdevice.appVersion != null && this.userdevice.appVersion != undefined) {
      appversion = this.userdevice.appVersion;
    }
    headerValues.upgraded = appversion; // 3.0+ returns distance instead of randomized location

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public public(me: any, aSoul: any): string {

    const teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      console.log('loadCurrentPage will use teleportationLocation: ' + JSON.stringify(teleportationLocation));
      me.location = teleportationLocation;
    }


    const otherLon = aSoul.location.coordinates[0];
    const otherLat = aSoul.location.coordinates[1];
    const lon = me.location.coordinates[0];
    const lat = me.location.coordinates[1];
    let distance: number = this.getDistanceFromLatLonInMiles(lat, lon, otherLat, otherLon);

    const isKm = me.distanceUnit != null && me.distanceUnit == 'km';
    if (isKm) {
      distance *= 1.60934;
    }

    const dist: string = distance.toFixed(0);
    let distText: string;
    if (dist == '1' || dist == '0') {
      distText = isKm ? this.translate.instant('within1Kilometer') : this.translate.instant('within1Mile');
    } else {
      distText = dist + ' ' + (isKm ? this.translate.instant('kilometers') : this.translate.instant('miles'));
    }

    return distText;
  }

  public superLikeSoul(soulId: string, soulTolike: string, msg: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/superLike';
    console.log('the superLikeSoul request: ' + theRequest);

    const headerValues: any = new Object();
    headerValues.soul = soulId;
    headerValues.soulToLike = soulTolike;
    headerValues.msg = msg;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    //let myHeaders = new HttpHeaders({'soul': soulId, 'soulToLike': soulTolike, 'msg': msg});
    console.log('superLikeSoul myHeaders: ' + JSON.stringify(myHeaders));

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public likeSoul(soulId: string, soulTolike: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/likeSoul?soul=' + soulId + "&soulToLike=" + soulTolike;
    console.log('the likeSoul request: ' + theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public excludeSoul(soulId: string, soulToRemove: string, userData: any): Observable<any> {
    return this.removeSoul(soulId, soulToRemove, 'exclude', userData);
  }

  public blockSoul(soulId: string, soulToRemove: string, userData: any): Observable<any> {
    return this.removeSoul(soulId, soulToRemove, 'block', userData);
  }

  public reportSoul(soulId: string, soulToRemove: string, reportReasons: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/removeSoul?soul=' + soulId + "&soulToRemove=" + soulToRemove + "&removeType=report&reportReasons=" + encodeURIComponent(reportReasons);
    console.log('the reportSoul request: ' + theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  private removeSoul(soulId: string, soulToRemove: string, removeType: string, userData: any): Observable<any> {
    const theRequest: string = environment.mainServer + '/soul/removeSoul?soul=' + soulId + "&soulToRemove=" + soulToRemove + "&removeType=" + removeType;
    console.log('the removeSoul request: ' + theRequest);

    const headerValues: any = new Object();
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }
    const myHeaders = new HttpHeaders(headerValues);

    return this.http.get(theRequest, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public viewProfilePublic(profileUserId: any): Observable<any> {
    const thePostURL: string = environment.mainServer + '/soul/getPublicProfileById';

    const headerValues: any = new Object();
    headerValues.idtoget = profileUserId;

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }


  public completePurchase(userData: any, product: any): Observable<any> {
    const thePostURL: string = environment.mainServer + '/soul/purchase2';
    const headerValues: any = new Object();
    headerValues.soul = userData?._id.$oid;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }


    const myHeaders = new HttpHeaders(headerValues);

    console.log('thePostURL: ' + thePostURL);
    return this.http.post(thePostURL, product, {
      headers: myHeaders,
      responseType: 'text'
    }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public getRefreshMyData(userData: any): Observable<any> {
    const userId = userData?._id.$oid;
    const thePostURL: string = environment.mainServer + '/soul/refreshMyData';

    const headerValues: any = new Object();
    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    return this.http.post(thePostURL, '', { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );
  }

  public async uploadAudio(
    localFile: string,
    userData: any,
    filename: string,
    webAudio?: { base64?: string | null; mimeType?: string }
  ): Promise<FileUploadResult> {
    try {
      const userId = userData?._id.$oid;
      console.log('userData._id: ' + userId);

      const thePostURL: string = environment.mainServer + '/soul/audio';
      console.log('The upload file URL: ' + thePostURL);
      console.log('localFile: ' + localFile);

      // Cordova FileTransfer cannot read Capacitor web paths like `/DATA/record.webm`.
      if (!Capacitor.isNativePlatform()) {
        return this.uploadAudioViaHttp(userData, filename, webAudio);
      }

      const options: FileUploadOptions = {
        fileName: filename,
      };

      if (userId != null) {
        options.params = { 'owner': userId };
      }

      if (userData.hash != null) {
        options.headers = { 'key': userData.hash };
      }

      const result = await this.fileTransfer.upload(localFile, thePostURL, options);
      return result;
    } catch (error) {
      console.error('Upload failed', error);
      throw error;
    }
  }

  private async uploadAudioViaHttp(
    userData: any,
    filename: string,
    webAudio?: { base64?: string | null; mimeType?: string }
  ): Promise<FileUploadResult> {
    const userId = userData?._id?.$oid;
    const mimeType = webAudio?.mimeType || this.audioMimeFromFilename(filename);
    let base64 = webAudio?.base64 || null;

    if (!base64) {
      const stored = await Filesystem.readFile({
        path: filename,
        directory: Directory.Data,
      });
      base64 = typeof stored.data === 'string' ? stored.data : null;
    }

    if (!base64) {
      throw new Error('No audio data available to upload');
    }

    const blob = this.base64ToBlob(base64, mimeType);
    const formData = new FormData();
    formData.append('file', blob, filename);
    if (userId) {
      formData.append('owner', userId);
    }

    let headers = new HttpHeaders();
    if (userData?.hash != null) {
      headers = headers.set('key', userData.hash);
    }

    const response = await firstValueFrom(
      this.http.post(environment.mainServer + '/soul/audio', formData, {
        headers,
        responseType: 'text',
      }).pipe(
        timeout(environment.requestTimeout),
        catchError(this.handleError)
      )
    );

    return {
      bytesSent: blob.size,
      responseCode: 200,
      response,
      headers: {},
    } as FileUploadResult;
  }

  private audioMimeFromFilename(filename: string): string {
    const lower = (filename || '').toLowerCase();
    if (lower.endsWith('.webm')) {
      return 'audio/webm';
    }
    if (lower.endsWith('.m4a') || lower.endsWith('.mp4')) {
      return 'audio/mp4';
    }
    if (lower.endsWith('.ogg')) {
      return 'audio/ogg';
    }
    if (lower.endsWith('.wav')) {
      return 'audio/wav';
    }
    return 'audio/3gpp';
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const cleaned = base64.includes(',') ? base64.split(',')[1] : base64;
    const binary = atob(cleaned);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
  }


  public async downloadAudio(fileId: string, localDir: string, localFileName: string): Promise<any> {
    console.log('Will download audio for: ' + fileId);
    const url: string = environment.mainServer + '/soul/audio/' + fileId;
    console.log('Will download audio to: ' + Directory.Data + "/" + localFileName);
    console.log('Will download audio from URL: ' + url);

    this.fileTransfer = FileTransfer.create();
    return this.fileTransfer.download(url, Directory.Data + "/" + localFileName);
  }

  public validatePhoto(userData: any, img_base64: any): Observable<any> {
    const userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    const thePostURL: string = environment.mainServer + '/faces/uploadSelfie';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public validatePose(userData: any, img_base64: any): Observable<any> {
    const userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    const thePostURL: string = environment.mainServer + '/faces/uploadPoseSelfie';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public sendCode(userData: any, phoneNumber: any) {
    const userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("phoneNumber: ", phoneNumber)
    const thePostURL: string = environment.mainServer + '/phone/send-code';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    const body = {
      phoneNumber: phoneNumber
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public verifyCode(userData: any, code: any, phoneNumber: any) {
    const userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("code: ", code)
    console.log("phoneNumber: ", phoneNumber)
    const thePostURL: string = environment.mainServer + '/phone/verify-code';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    const body = {
      phoneNumber: phoneNumber,
      code: code
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }

  public validateProfile(userData: any) {
    const userId = userData._id.$oid;

    const thePostURL: string = environment.mainServer + '/faces/validateProfile';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    // headerValues.Content-Type = "application/JSON";

    const myHeaders = new HttpHeaders(headerValues).set('Content-Type', 'application/json');

    return this.http.post(thePostURL, JSON.stringify('{}'), { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public redoValidation(userData: any) {
    const userId = userData._id.$oid;

    const thePostURL: string = environment.mainServer + '/faces/resetSelfies';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    // headerValues.Content-Type = "application/JSON";

    const myHeaders = new HttpHeaders(headerValues).set('Content-Type', 'application/json');

    return this.http.post(thePostURL, JSON.stringify('{}'), { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      //retry(3), // retry a failed request up to 3 times
      catchError(this.handleError)
    );

  }

  public updateProfilePicture(userData: any, img_base64: any): Observable<any> {
    const userId = userData._id.$oid;
    console.log("userId: ", userId)
    console.log("img_base64: ", img_base64)
    const thePostURL: string = environment.mainServer + '/faces/updateProfilePicture';

    const headerValues: any = new Object();

    headerValues.soul = userId;
    if (userData.hash != null) {
      headerValues.key = userData.hash;
    }

    const myHeaders = new HttpHeaders(headerValues);

    const body = {
      img1_base64: img_base64
    };

    return this.http.post(thePostURL, body, { headers: myHeaders, responseType: 'text' }).pipe(
      timeout(20000),
      catchError(this.handleError)
    );
  }
}
